export default "__VITE_ASSET__DHhzCkZs__"